import { DELETE_QUESTION as SOCKET_DELETE_QUESTION, SEND_ANSWER_RESULTS as SOCKET_SEND_ANSWER_RESULTS } from '../../events/DashboardToServer'
import { DO_ANSWER as SOCKET_DO_ANSWER } from '../../events/ClientToServer'

export const START_BET = 'START_BET'
export const PLACE_BET = 'PLACE_BET'
export const BET_PLACED = 'BET_PLACED'
export const ASK_QUESTION = 'ASK_QUESTION'
export const DO_ANSWER = 'DO_ANSWER'
export const GET_QUESTIONS = 'GET_QUESTIONS'
export const RECEIVE_QUESTIONS = 'RECEIVE_QUESTIONS'
export const EDIT_QUESTION = 'EDIT_QUESTION'
export const SAVE_QUESTION = 'SAVE_QUESTION'
export const SAVED_QUESTION = 'SAVED_QUESTION'
export const DELETE_QUESTION = 'DELETE_QUESTION'
export const DELETED_QUESTION = 'DELETED_QUESTION'
export const SEND_ANSWER_RESULTS = 'SEND_ANSWER_RESULTS'

export const startBet = (socket, game_id, question, seconds) => {
    const betMs = seconds * 1000
    socket.emit(START_BET, game_id, question, betMs)
    return { type: START_BET, game_id, question, betMs }
}



export const placeBet = (socket, game_id, question, bet) => {
    socket.emit(PLACE_BET, { game_id:game_id, question_id: question.id, bet })
    return { type: PLACE_BET, game_id, question, bet }
}


export const askQuestion = (socket, game_id, question, seconds) => {
    const msToAnswer = seconds * 1000
    const { id, text } = question
    if (socket)
        socket.emit(ASK_QUESTION, game_id,  { id, text }, msToAnswer)
    return { type: ASK_QUESTION, game_id, question: { id, text }, msToAnswer }
}


export const doAnswer = (socket, game_id, question, answer, answerMs) => {
    socket.emit(SOCKET_DO_ANSWER, game_id, { question_id: question.id, answer, answerMs })
    return { type: DO_ANSWER, game_id,  question, answer }
}

export const sendAnswerResults = (socket, game_id, question_id) => {
    socket.emit(SOCKET_SEND_ANSWER_RESULTS, game_id, { question_id })
    return {type: SEND_ANSWER_RESULTS, game_id, question_id }
}

export const getQuestions = (socket, providerId) => {
    socket.emit(GET_QUESTIONS, { providerId })
    return { type: GET_QUESTIONS, providerId }
}

export const receiveQuestions = ({ questions, providerId }) => {
    return { type: RECEIVE_QUESTIONS, questions, providerId }
}

export const editQuestion = (question) => {
    return { type: EDIT_QUESTION, question }
}

export const saveQuestion = (socket, providerId, question) => {
    const questionToSave = { ...question, id: question.id || 'new-' + Math.random() }
    socket.emit(SAVE_QUESTION, { question: questionToSave })
    return { type: SAVE_QUESTION, providerId, question: questionToSave }
}

export const savedQuestion = (question, prevId) => {
    return { type: SAVED_QUESTION, question, prevId }
}

export const deleteQuestion = (socket, question) => {
    socket.emit(SOCKET_DELETE_QUESTION, { question })
    return { type: DELETE_QUESTION, question }
}

export const deletedQuestion = question => {
    return {type: DELETED_QUESTION, question }
}



// WEBPACK FOOTER //
// ./src/reducers/questions/actions.js